module.exports = __webpack_public_path__ + "img/Bear16.870c5bf5.jpg";